import { createContext } from 'react';

import { useInfieldLogout } from '../../../hooks/use-infield-logout';
import { useIsDesktop } from '../../../hooks/useIsDesktop';
import { useIsAppConfiguratorQuery } from '../hooks/use-query/use-is-app-configurator-query';

export interface AppConfigErrorScreenContextInterface {
  useInfieldLogout: () => Pick<ReturnType<typeof useInfieldLogout>, 'logout'>;
  useIsDesktop: () => ReturnType<typeof useIsDesktop>;
  useIsAppConfiguratorQuery: () => Pick<
    ReturnType<typeof useIsAppConfiguratorQuery>,
    'data'
  >;
}

export const defaultValue: AppConfigErrorScreenContextInterface = {
  useInfieldLogout,
  useIsDesktop,
  useIsAppConfiguratorQuery,
};

export const AppConfigErrorScreenContext =
  createContext<AppConfigErrorScreenContextInterface>(defaultValue);
